import React from "react";

export const Footer = () => {
  return (
    <footer className="w-full bg-slate-900 text-gray-200">
      <div className="flex flex-row max-w-[1240px] px-4 py-6 mx-auto justify-between items-center">
        <p className="text-sm md:text-base">
          2025 Valiant. All rights reserved.
        </p>
        
        <button
          className="py-2 px-4 text-sm md:text-base text-white bg-transparent border border-white/30 rounded hover:bg-white/10 transition-all"
          onClick={() => { window.location.href = "mailto:info@valiantintelligence.com" }}
        >
          Contact Us
        </button>
      </div>
    </footer>
  );
}
